export default __webpack_public_path__ + "static/media/newsletterNC.ef663575.svg";